import React, {Component} from "react";
import {withCookies} from "react-cookie";

class PlaidLinkButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            csrfToken: props.csrfToken
        };
    }

    render() {
        return (
            <div>
                <div className={"ui centered raised fluid card outer"}>
                    <button className={"ui button blue fluid plaid-link-button"} data-csrf_token={this.state.csrfToken}>
                        <i className={"add icon"}></i> Link an Account
                    </button>

                </div>
            </div>
        )
    }
}

export default PlaidLinkButton;